import { ConsultantEdit } from '@/components/admin/edit/ConsultantEdit';
import { Consultant } from '@/types';
import { useQuery } from '@tanstack/react-query';
import { Form, Flex, Button, Typography } from 'antd';
import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router';
import { LeftOutlined } from '@ant-design/icons';
import { getAdminConsultantById } from '@/api/franchisee';

const EditDetailsPageConsultant = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm<Partial<Consultant>>();

  const { data: consultant } = useQuery<Consultant | null, Error>({
    queryKey: ['consultant', id],
    queryFn: () => getAdminConsultantById(id || ''),
  });

  useEffect(() => {
    if (!consultant) return;
    form.setFieldsValue({
      ...consultant,
      // TCX-507: groups come back as {id,name}; the Select works on ids.
      groups: (consultant.groups?.map((g) => g.id) ?? []) as any,
    });
  }, [form, consultant]);

  const onBack = () => {
    navigate(`/control-panel/consultants/${id}`);
  };

  const onCancel = () => {
    navigate(`/control-panel/consultants/${id}`);
  };
  return (
    <>
      <Flex justify="start" align="start" gap={8} vertical>
        <Button
          type="link"
          icon={<LeftOutlined />}
          onClick={onBack}
          style={{ color: '#22252D', fontWeight: 500, paddingLeft: 0 }}
        >
          Back
        </Button>
        <Typography.Title
          level={3}
          style={{
            margin: '0 0 24px',
          }}
        >
          Edit User
        </Typography.Title>
      </Flex>
      <ConsultantEdit
        consultant={consultant as Consultant}
        form={form}
        onCancel={onCancel}
      />
    </>
  );
};

export default EditDetailsPageConsultant;
